<div class="dash-page">
  <div class="page-header">
    <app-page-title></app-page-title>
  </div>

  <!-- 4 Card Icon Layout -->
  <div class="row g-2 g-sm-3 mb-3 mb-md-4 dash-kpi-row" aria-label="ข้อมูลสรุปภาพรวม">
    <div class="col-6 col-sm-auto">
      <a class="dash-kpi-card dash-kpi-card-purple" routerLink="/trade" [queryParams]="{tab: 'RECORDS'}">
        <div class="dash-kpi-top">
          <div class="dash-kpi-icon-wrap">
            <img src="assets/images/icons/product.png" alt="รายการซื้อขาย" class="dash-kpi-img" />
          </div>
          <div class="dash-kpi-value-wrap">
            <strong class="dash-kpi-value">
              @if (loading()) {
                -
              } @else {
                {{ totalCount().toLocaleString('th-TH') }}
              }
            </strong>
          </div>
        </div>
        <div class="dash-kpi-title-row">
          <span class="dash-kpi-label">รายการซื้อขาย</span>
          <span class="dash-kpi-arrow" aria-hidden="true">&raquo;</span>
        </div>
      </a>
    </div>
    <div class="col-6 col-sm-auto">
      <a class="dash-kpi-card dash-kpi-card-green" routerLink="/trade" [queryParams]="{tab: 'OFFERS'}">
        <div class="dash-kpi-top">
          <div class="dash-kpi-icon-wrap">
            <img src="assets/images/icons/shopping-cart.png" alt="ใบขาย" class="dash-kpi-img" />
          </div>
          <div class="dash-kpi-value-wrap">
            <strong class="dash-kpi-value">
              @if (loading()) {
                -
              } @else {
                {{ offersCount().toLocaleString('th-TH') }}
              }
            </strong>
          </div>
        </div>
        <div class="dash-kpi-title-row">
          <span class="dash-kpi-label">ใบขาย</span>
          <span class="dash-kpi-arrow" aria-hidden="true">&raquo;</span>
        </div>
      </a>
    </div>
    <div class="col-6 col-sm-auto">
      <a class="dash-kpi-card dash-kpi-card-amber" routerLink="/trade" [queryParams]="{tab: 'STOCK'}">
        <div class="dash-kpi-top">
          <div class="dash-kpi-icon-wrap">
            <img src="assets/images/icons/cardboard.png" alt="stock สินค้า" class="dash-kpi-img" />
          </div>
          <div class="dash-kpi-value-wrap">
            <strong class="dash-kpi-value">
              @if (loading()) {
                -
              } @else {
                {{ stockCount().toLocaleString('th-TH') }}
              }
            </strong>
          </div>
        </div>
        <div class="dash-kpi-title-row">
          <span class="dash-kpi-label">stock สินค้า</span>
          <span class="dash-kpi-arrow" aria-hidden="true">&raquo;</span>
        </div>
      </a>
    </div>
    <div class="col-6 col-sm-auto">
      <a class="dash-kpi-card dash-kpi-card-blue" routerLink="/chat">
        <div class="dash-kpi-top">
          <div class="dash-kpi-icon-wrap">
            <img src="assets/images/icons/users.png" alt="ผู้ติดต่อ" class="dash-kpi-img" />
          </div>
          <div class="dash-kpi-value-wrap">
            <strong class="dash-kpi-value">
              {{ contactsCount().toLocaleString('th-TH') }}
            </strong>
          </div>
        </div>
        <div class="dash-kpi-title-row">
          <span class="dash-kpi-label">ผู้ติดต่อ</span>
          <span class="dash-kpi-arrow" aria-hidden="true">&raquo;</span>
        </div>
      </a>
    </div>
  </div>

  <div class="dash-header">
    <p class="dash-subtitle">ภาพรวมข้อมูลการซื้อ-ขายสินค้าเกษตร</p>
  </div>

  <div class="row g-3 align-items-end mb-3 mb-md-4" aria-label="ตัวกรองข้อมูลแดชบอร์ด">
    <label class="dash-filter-label col-auto" for="dashboard-year">ปี</label>
    <div class="col-auto">
      <select id="dashboard-year" class="form-select form-select-sm" autocomplete="off" [value]="selectedYear()"
              (change)="onYearChange($event)">
        @for (year of yearOptions; track year.gregorian) {
          <option [value]="year.gregorian">{{ year.buddhist }}</option>
        }
      </select>
    </div>

    <label class="dash-filter-label col-auto" for="dashboard-product">สินค้า</label>
    <div class="col-auto">
      <select id="dashboard-product" class="form-select form-select-sm" autocomplete="off"
              [value]="selectedProductName()"
              [disabled]="loadingProductNames()" (change)="onProductNameChange($event)">
        <option value="">สินค้าทั้งหมด</option>
        @for (productName of productNames(); track productName) {
          <option [value]="productName">{{ productName }}</option>
        }
      </select>
    </div>
  </div>

  <!-- Top Section -->
  <div class="row g-2 g-sm-3 g-md-4 mb-3 mb-md-4">
    <!-- Sales per month -->
    <div class="col-12 col-lg-8">
      <div class="dash-card">
        <h6 class="dash-card-title">จำนวนรายการขายในแต่ละเดือน</h6>
        @if (loading()) {
          <div class="dash-empty">กำลังโหลด…</div>
        } @else if (!hasMonthlyData()) {
          <div class="dash-empty">
            <i class="bi bi-inbox dash-empty-icon" aria-hidden="true"></i>
            <span>ไม่มีจำนวนรายการขายในแต่ละเดือน</span>
          </div>
        } @else {
          <div echarts [options]="monthlyChartOptions()" style="height: 260px;"></div>
        }
      </div>
    </div>
    <div class="col-12 col-lg-4">
      <div class="dash-card h-100">
        <div class="d-flex align-items-center justify-content-between mb-2 pb-2 border-bottom">
          <h6 class="dash-card-title mb-0 pb-0 border-0">ผู้ติดต่อ</h6>
          <a routerLink="/chat" class="small text-primary-accent text-decoration-none">ดูทั้งหมด</a>
        </div>
        @if (contacts().length === 0) {
          <div class="dash-empty">
            <i class="bi bi-inbox dash-empty-icon" aria-hidden="true"></i>
            <span>ยังไม่มีผู้ติดต่อ</span>
          </div>
        } @else {
          <div class="dash-contact-list">
            @for (contact of contacts(); track contact.contactId) {
              <a class="dash-contact-item" routerLink="/chat">
                <div class="dash-contact-avatar">
                  <img [src]="contact.avatarUrl || 'assets/characters/character-default1.png'"
                       [alt]="contact.displayName"/>
                  <span class="dash-presence-dot" [class.online]="contact.online"></span>
                </div>
                <div class="dash-contact-meta">
                  <div class="d-flex justify-content-between align-items-baseline gap-1">
                    <strong class="dash-contact-name">{{ contact.displayName || contact.email }}</strong>
                    <span class="dash-contact-time">{{ formatMessageTime(contact.lastMessageAt) }}</span>
                  </div>
                  <p class="dash-contact-preview mb-0">{{ contact.lastMessage || 'ยังไม่มีข้อความ' }}</p>
                </div>
                @if ((contact.unreadCount ?? 0) > 0) {
                  <span class="dash-contact-badge">{{ contact.unreadCount }}</span>
                }
              </a>
            }
          </div>
        }
      </div>
    </div>
  </div>

  <!-- Latest sales as horizontal cards -->
  <div class="row mt-3 mt-md-4">
    <div class="col-12 col-lg-6">
      <div class="d-flex align-items-end justify-content-between mb-3">
        <h6 class="dash-table-title mb-0">รายการซื้อ - ขาย 5 รายการล่าสุด</h6>
      </div>
      @if (loading()) {
        <div class="dash-empty">กำลังโหลด…</div>
      } @else if (latestSold().length === 0) {
        <div class="dash-empty">
          <i class="bi bi-inbox dash-empty-icon" aria-hidden="true"></i>
          <span>ไม่มีข้อมูล</span>
        </div>
      } @else {
        @for (record of latestSold(); track record.id) {
          <div class="dash-record-card">
            <a class="dash-record-inner" [routerLink]="['/trade', record.id]">
              <div class="dash-record-thumb">
                <app-fruit-icon class="dash-fruit" [product]="record.productName || ''"></app-fruit-icon>
              </div>
              <div class="dash-record-body">
                <div class="dash-record-left">
                  <div class="d-flex flex-wrap align-items-center column-gap-3 row-gap-1">
                    <span class="fw-semibold">{{ record.productName || 'ไม่ระบุสินค้า' }}</span>
                    <span class="text-secondary small">{{ qty(record) }}</span>
                    @if (soldQty(record) > 0) {
                      <span class="dash-badge dash-badge-green">ขายแล้ว</span>
                    } @else {
                      <span class="dash-badge dash-badge-amber">รอผู้ซื้อ</span>
                    }
                  </div>
                  <div class="d-flex flex-wrap align-items-center column-gap-3 row-gap-1 mt-1 small text-secondary">
                    <span>อัปเดต: {{ record.recordedAt || record.updatedAt | thaidatetime }}</span>
                  </div>
                  <div class="small text-secondary" style="display: flex; flex-direction: column; gap: 0.15rem;">
                    <span>ผู้ซื้อ: {{ buyerName(record) }}</span>
                    <span>ผู้ขาย: {{ sellerName(record) }}</span>
                  </div>
                </div>
                <!-- lotCode display temporarily hidden
                <div class="dash-record-lot">{{ record.lotCode || record.recordCode }}</div>
                -->
              </div>
              <i class="bi bi-chevron-right dash-record-arrow"></i>
            </a>
          </div>
        }
      }
    </div>
  </div>
</div>
